import { Component, OnInit, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { MatRadioChange, MatRadioButton } from '@angular/material';

import { Product } from '../../models/product';

import { OfferEntryDataService } from '../../../core/services/offer-entry-data.service';

import { Subscription } from 'rxjs/Subscription';

import { UtilsService } from '../../../core/services/utils.service';

@Component({
    selector: 'app-product-selection',
    templateUrl: './product-selection.component.html',
    styleUrls: ['./product-selection.component.css']
})
export class ProductSelectionComponent implements OnInit {
    debugVerbose: boolean = false;

    offerEntryDataSubscription: Subscription;
    meterUsageDataSubscription: Subscription;

    @Input() radioGroupName: String;
    @Output() selectedProductChangedEvent: EventEmitter<Product> = new EventEmitter<Product>();

    products: Product[];
    @Input() program: string;

    constructor(
        private offerEntryDataService: OfferEntryDataService,
        private utilsService: UtilsService
    ) {
    }

    ngOnInit() {

        this.offerEntryDataService.loadProductData(this.program).subscribe((metadataResponse) => {
            this.utilsService.debugLog('Product Metadata Response: ', metadataResponse);
            if (metadataResponse != null) {
                this.products = [];
                let selectedProduct: Product = null;
                let isDefault: boolean = false;
                metadataResponse.forEach(product => {
                    const tmpProduct: Product = new Product();
                    tmpProduct.name = product.product_name;
                    tmpProduct.productCode = product.product_code;
                    tmpProduct.productId = Number(product.product_id);
                    if (product.default_selected && selectedProduct === null) {
                        selectedProduct = tmpProduct;
                        isDefault = true;
                    } else {
                        isDefault = false;
                    }
                    tmpProduct.isSelected = isDefault;

                    this.products.push(tmpProduct);
                    this.utilsService.debugLog('product-selection', tmpProduct);
                });
                if (selectedProduct) {
                    this.selectedProductChangedEvent.emit(selectedProduct);
                }
            }
        });

    }

    productChanged(mrChange: MatRadioChange) {
        const mrButton: MatRadioButton = mrChange.source;
        if (mrButton.checked) {
            this.products.forEach(product => {
                if (product.productCode === mrButton.value) {
                    this.selectedProductChangedEvent.emit(product);
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/product-selection/product-selection.component.ts